<template>
    <div class="order" >
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>货款付款计划表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        
        </div>
    </div>
</template>
<script>
import { firstHeader,border,oneT,twoT } from '@/assets/js/hkfk'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
        carType:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options: {
                container: 'luckysheet', //容器id名
                title: '货款付款计划表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证
	                cellFormat: false // 设置单元格格式
                }
                // showstatisticBar
            },
        }
    },
    mounted(){
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        // this.handleTest()
        this.getExcelDate()
       
    },
    methods:{
                // 计算年月
        getExcelDate(){
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);
            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.warning("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.warning("结束日期必须在开始日期之后")
            }
            this.date = date
            this.handleTest()
        },
        demo(){
           
           
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                this.$store.state.excelLoading = false
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
              
                let bgeArr = []
                let bgfArr = []
                this.mydata[0].celldata.map(item=>{
                    if(item.r>=1&&item.r<window.luckysheet.getAllSheets()[0].data.length&&item.c==1&&item.v.m.length!=0&&item.v.m.indexOf('.')==-1){
                        bgeArr.push(`B${item.r+1}:EX${item.r+1}`)
                     
                    }
                    if(item.r>=1&&item.r<window.luckysheet.getAllSheets()[0].data.length&&item.c==2&&item.v.m.indexOf('付款合计')!==-1){
                        bgfArr.push(`A${item.r+1}:EX${item.r+1}`)
                    }
                })
             
                if(bgeArr.length>0&&bgfArr.length>0){
                    window.luckysheet.setRangeFormat("bg", '#eee', {range:[...bgeArr]})
                    window.luckysheet.setRangeFormat("bg", '#f9ded1', {range:[...bgfArr]})
                    
                }
                
                
              
                
            }
        },
        handleTest(){
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 2}
                    },
                   
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "当前表格不可以进行修改", // 弹

                            // allowRangeList: [
                            // 	{ sqref: '$A$19:$X$20' },//设置A2~D6为可编辑区域，其它区域不可编辑
                               
                            // ],
                        },
                        borderInfo: [...border],
                    },
                    
                    
                    
                },
            ];
            // 表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+firstHeader.length,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })

            }
            let saleHeader = ['订单计划','应付货款','每月付款计划-分类型']
            let indexOne = ['1','2','3']
            // 合计项目名称
            this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByTypeSum.map((item,i)=>{
                saleHeader.push(item.paymentTypeName)
                indexOne.push(`3.${i+1}`)
            })
            saleHeader.push('每月付款计划-分方式')
            indexOne.push(`4`)
            this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByMethodSum.map((item,i)=>{
                saleHeader.push(item.methodName)
                indexOne.push(`4.${i+1}`)
            })
           
            saleHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:2,
                        v:{
                            v:item,
                            ht:0
                        },
                    }
                )
            })
            // this.mydata[0].frozen.range.row_focus = saleHeader.length
        
            // 添加序号数据项
            
            indexOne.map((item,index)=>{
                if(item.indexOf('.')==-1){
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:1,
                                v:item,
                                
                                v:{
                                    v:item,
                                    ht:0,
                                    bg:'#eee',
                                    ct: {
                                        "fa": "@",
                                        "t": "s"
                                    },
                                },
                            }
                        )
                        
                    }else{
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:1, 
                                v:{ 
                                    v:item,
                                    ht:2,
                                    bg:'#fff',
                                    ct: {
                                        "fa": "@",
                                        "t": "s"
                                    },
                                },
                            }
                        )
                    }
            })
            // 合并项：合计
            let mc = [
                {
                    "r": 1,
                    "c": 0,
                    "v": {
                        "v":'合计',
                        "bl": 1, 
                        'ht':0
                    },
                    "mc": {      
                        "r": 1,  
                        "c": 0,  
                        "rs": saleHeader.length, 
                        "cs": 1  
                    },

                }, 
            ]
            let merge = {
                "1_0": {
                    "r": 1,
                    "c": 0,
                    "rs": saleHeader.length, 
                    "cs": 1
                },
            }
            // 车型单项 科目名称+序号
            let carItem = []
            this.data.paymentScheduleForGoodsEachCarModel.map(item=>{
                let arr1 = [{name:'订单计划',index:1},{name:'应付货款',index:2},{name:'付款类型',index:3}]
                item.eachPaymentTypeList.map(data=>{
                    arr1.push({name:data.paymentTypeName,index:''})
                })
                carItem.push(...arr1,{name:item.carModelName+'每月计划付款合计',index:'',status:item.carModelName,cd:arr1.length})
            })
      
            carItem.map((item,i)=>{
                    let bg = ''
                    if(item.status&&item.name){
                        bg = '#f9ded1'
                    }
                    this.mydata[0].celldata.push(
                        
                    {
                        r:saleHeader.length+1+i,
                        c:2, 
                        v:{ 
                            v:item.name,
                            ht:0,
                            bg:bg
                        },
                    },
                    {
                        r:saleHeader.length+1+i,
                        c:1, 
                        v:{ 
                            v:item.index,
                            ht:0,
                            bg:bg
                        },
                    }
                    )
                    
                       
                    

                    if(item.status){
                        mc.push({
                            "r": saleHeader.length+1+i-item.cd,
                            "c": 0,
                            "v": {
                                "v":item.status,
                                'ht':0,
                                'bg':'#eee'
                            },
                            "mc": {       
                                "r": saleHeader.length+1+i-item.cd,   
                                "c": 0,   
                                "rs": item.cd, 
                                "cs": 1   
                            },
                        },)
                        merge[`${saleHeader.length+1+i-item.cd}_0`] = { 
                           "r": saleHeader.length+1+i-item.cd,
                           "c": 0,
                           "rs": item.cd,
                           "cs": 1
                        }
                    }
            })
            this.mydata[0].celldata.push(...mc)
            // 合并配置
            this.mydata[0].config.merge = merge
            
                    
            

           this.fillPosition()
            // this.demo()
        },
        fillPosition(){
           
            let array = this.mydata[0].celldata
            array.map(a=>{
                this.tableData.paymentScheduleForGoodsEachCarModel.map((item,n)=>{
                    if(a.v.v==item.carModelName){
                        item.r = a.r
                    }
                    item.planCountResultList.map(b=>{//应付货款
                        if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                            b.c = a.c
                        }
                    })
                    
                    item.eachPaymentTypeList.forEach((b,i)=>{
                        let hj= 5+this.tableData.paymentScheduleForGoodsColumn.monthlyPayPlanByTypeSum.length+this.tableData.paymentScheduleForGoodsColumn.monthlyPayPlanByMethodSum.length
                        b.r = hj+n*(4+item.eachPaymentTypeList.length)+3+i
                        b.paymentTypeAllMonth.monthAndValue.forEach((data,j)=>{
                            // data.r = b.r+
                            data.total = item.eachPaymentTypeTotal[i]
                            if(a.v.v==this.getExcelData(data.eachMonthLocalDate)){
                                data.c = a.c
                            }
                        })
                        
                    })

                })
                this.tableData.paymentScheduleForGoodsEachMonth.map(b=>{
                    if(a.v.v==this.getExcelData(b.month)){
                        b.c = a.c
                    }
                    // 行 
                    if(a.r>3&&a.r<(4+this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByTypeSum.length)&&a.c==2){
                 
                        b.monthlyPayPlanByType.map(c=>{
                            if(a.v.v==c.paymentTypeName){
                                c.r = a.r
                            }
                        }) 
                    }   
                     if(a.r>(4+this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByTypeSum.length)&&a.r<(5+this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByTypeSum.length+this.data.paymentScheduleForGoodsColumn.monthlyPayPlanByMethodSum.length)&&a.c==2){
                        b.monthlyPayPlanByMethod.map(d=>{
                            if(a.v.v==d.methodName){
                                d.r = a.r
                            }
                        })  
                     }
                    
                    
                   
                })
            })

            this.fillData()
        },
        fillData(){
            // 合计*合计
            let obj = this.tableData.paymentScheduleForGoodsColumn
            this.mydata[0].celldata.push(
                {
                    r:1,
                    c:4,
                    v:{ 
                        v:obj.orderPlanSum,
                        ht:0
                    },
                },
                {
                    r:2,
                    c:4,
                    v:{ 
                        v:obj.accountsPayableSum,
                        ht:0
                    },
                },
                {
                    r:3,
                    c:4,
                    v:{ 
                        v:obj.monthlyPayPlanByTypeTotalSum,
                        ht:0
                    },
                },
                {
                    r:4+obj.monthlyPayPlanByTypeSum.length,
                    c:4,
                    v:{ 
                        
                        v:obj.monthlyPayPlanByMethodTotalSum,
                        ht:0
                    },
                },
            )
            obj.monthlyPayPlanByTypeSum.map((data,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:4+i,
                        c:4,
                        v:{ 
                            v:data.value,
                            ht:0
                        },
                    }
                )
            })
            obj.monthlyPayPlanByMethodSum.map((data,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:5 + obj.monthlyPayPlanByTypeSum.length+i,
                        c:4,
                        v:{ 
                            v:data.value,
                            ht:0
                        },
                    }
                )
            })

            // 合计
            this.tableData.paymentScheduleForGoodsEachMonth.map(item=>{
                this.mydata[0].celldata.push(
                        {
                            r:1,
                            c:item.c,
                            v:{ 
                                v:item.orderPlan,//订单计划
                                ht:0
                            },
                        },
                        {
                            r:2,
                            c:item.c,
                            v:{ 
                                v:item.accountsPayable,//应付货款
                                ht:0
                            },
                        },
                        {
                            r:3,
                            c:item.c,
                            v:{ 
                                v:item.monthlyPayPlanByTypeTotal,//类型
                                ht:0
                            },
                        },
                        {
                            r:4+item.monthlyPayPlanByType.length,
                            c:item.c,
                            v:{ 
                                v:item.monthlyPayPlanByMethodTotal,//方式
                                ht:0
                            },
                        },
                    )
                item.monthlyPayPlanByType.map(data=>{
                    this.mydata[0].celldata.push(
                        {
                            r:data.r,
                            c:item.c,
                            v:{ 
                                v:data.value,
                                ht:0
                            },
                        }
                    )
                })
                item.monthlyPayPlanByMethod.map(data=>{
                    this.mydata[0].celldata.push(
                        {
                            r:data.r,
                            c:item.c,
                            v:{ 
                                v:data.value,
                                ht:0
                            },
                        }
                    )
                })

            })
            
            // // 车型
            this.tableData.paymentScheduleForGoodsEachCarModel.map(item=>{
                item.planCountResultList.map(data=>{//订单计划
                    this.mydata[0].celldata.push(
                        {
                            r:item.r,
                            c:data.c,
                            v:{ 
                                v:data.orderPlanCount,
                                ht:0
                            },
                        }
                    )
                })
                
                item.accountsPayableResultList.map((data,i)=>{//应付货款
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+1,
                            c:i+5,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        }
                    )
                })
                item.paymentTypeList.map((data,i)=>{//付款类型
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+2,
                            c:i+5,
                            v:{ 
                                v:data,
                                ht:0
                            },
                        },
                    )
                })
                item.totalMoneyList.map((data,i)=>{//车型每月计划付款
                    this.mydata[0].celldata.push(
                        {
                            r:item.r+2+item.eachPaymentTypeList.length+1,
                            c:i+5,
                            v:{ 
                                v:data,
                                ht:0,
                                bg:'#f9ded1'
                            },
                        }
                    )
                })
                item.eachPaymentTypeList.map((data,i)=>{//付款类型下面
                   
                    data.paymentTypeAllMonth.monthAndValue.map((content,j)=>{
                     
                        this.mydata[0].celldata.push(
                            {
                                r:data.r,
                                c:content.c,
                                v:{ 
                                    v:content.payValue,
                                    ht:0
                                },
                            },
                            {
                                r:data.r,
                                c:4,
                                v:{ 
                                    v:content.total,
                                    ht:0
                                },
                            },
                            
                        )
                    })

                })

                this.mydata[0].celldata.push(
                    {
                        r:item.r+0,
                        c:4,
                        v:{ 
                            v:item.planCountTotal, //订单计划-合计
                            ht:0
                        },
                    },
                    {
                        r:item.r+1,
                        c:4,
                        v:{ 
                            v:item.accountsPayableTotal, //订单计划-合计
                            ht:0
                        },
                    },
                    {
                        r:item.r+2+item.eachPaymentTypeList.length+1,
                        c:4,
                        v:{ 
                            v:item.totalMoneyTotal, //订单计划-合计
                            ht:0,
                            bg:'#f9ded1'
                        },
                    },
                )

                // item.eachPaymentTypeList
            })
    

            this.demo()
        },
        getExcelData(str){
            let arr = str.substr(0,7).split("-")
            let date;
            if(arr[1].substr(0,1)==0){
                date = arr[0]+'年'+arr[1].substr(1,2)+'月'
            }else{
                date = arr[0]+'年'+arr[1]+'月'
            }
            return date

        },
    },
    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    position: relative;
  
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
    
        background: #fff;
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        // align-items: center;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>